import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetMachineExceptionImageReqData, GetMachineExceptionImageCommand } from "@/model/communication/logAnalysis/GetMachineExceptionImageCommand";
import { GetMachineExceptionImageResData } from "@/model/communication/logAnalysis/GetMachineExceptionImageResData";
import { SET_MACHINE_IMAGE_CACHE } from "./mutations";

export const FETCH_EXCEPTION_IMAGE = "FETCH_EXCEPTION_IMAGE";

export default {
    async [FETCH_EXCEPTION_IMAGE]({ commit }, payload) {
        let exc = payload.exc;
        let excHash = payload.excHash;
        try {
            this.reqData = new GetMachineExceptionImageReqData(payload.installationName, payload.serialNumber, exc, 600);
            var response: GetMachineExceptionImageResData = await new GetMachineExceptionImageCommand(this.reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.image && response.image.length > 0) {
                commit(SET_MACHINE_IMAGE_CACHE, [excHash, response.image]);
            }
        } catch (e) {
            console.log("Something went wrong sending GetMachineExceptionImageCommand request ", e);
        }
    },
};
